import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  Box,
  Button,
  Container, 
  Grid, 
  Typography,
  useTheme,
} from '@mui/material';
import {
  CloudUpload as CloudUploadIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { RootState } from '../store';
import { fetchStorageStats } from '../store/slices/storageSlice';
import { fetchRecentFiles, fetchFavoriteFiles } from '../store/slices/filesSlice';
import { Link } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';

// Import dashboard components
import StorageOverview from '../components/dashboard/StorageOverview';
import ActivityFeed from '../components/dashboard/ActivityFeed';
import QuickAccess from '../components/dashboard/QuickAccess';

const Dashboard: React.FC = () => {
  usePageTitle('Dashboard');
  const theme = useTheme();
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);
  const { loading: statsLoading, stats } = useSelector((state: RootState) => state.storage);
  const { recentFiles, favoriteFiles, loading: filesLoading } = useSelector((state: RootState) => state.files);

  useEffect(() => {
    dispatch(fetchStorageStats() as any);
    dispatch(fetchRecentFiles() as any);
    dispatch(fetchFavoriteFiles() as any);
  }, [dispatch]);

  return (
    <Box sx={{ py: 3 }}>
      {/* <Container maxWidth="lg"> */}
        <Grid container spacing={3}>
          {/* Header with welcome and actions */}
          <Grid item xs={12}>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'column', md: 'row' }, 
              justifyContent: 'space-between', 
              alignItems: { xs: 'flex-start', md: 'center'},
              mb: 2 
            }}>
              <Box>
                <Typography variant="h4" fontWeight={600} gutterBottom>
                  Welcome back{user?.name ? `, ${user.name}` : ''}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Here's an overview of your storage and recent activity
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', mt: { xs: 2, md: 0 }, gap: 1 }}>
                <Button 
                  variant="contained" 
                  startIcon={<CloudUploadIcon />}
                  component={Link}
                  to="/files"
                >
                  Upload Files
                </Button>
                <Button 
                  variant="outlined"
                  startIcon={<SearchIcon />}
                  component={Link}
                  to="/files"
                >
                  Browse Files
                </Button>
              </Box>
            </Box>
          </Grid>
          
          {/* Storage overview */}
          <Grid item xs={12} md={4}>
            <StorageOverview />
          </Grid>
          
          {/* Activity feed */}
          <Grid item xs={12} md={8}>
            <ActivityFeed loading={filesLoading} />
          </Grid>
          
          {/* Quick access files and folders */}
          <Grid item xs={12}>
            <QuickAccess />
          </Grid>
        </Grid>
      {/* </Container> */}
    </Box>
  );
};

export default Dashboard; 